export enum EContent {
  PIPELINE = "Pipeline",
  PORTFOLIO = "Portfolio",
  DISCOVER = "Discover",
  DASHBOARD = "Dashboard",
  PROFILE = "Profile"
}

export enum EView {
  LIST = "List",
  GRID = "Grid"
}

export const blockedStages = ["Inbox", "Completed"];
